import { HttperrorInterceptor } from './httperror.interceptor';
import { AuthorizationInterceptor } from './authorization.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Input } from '@angular/core';

export const httpInterceptProviders = [
    { provide: HTTP_INTERCEPTORS, useClass: AuthorizationInterceptor, multi: true},
  //  { provide: HTTP_INTERCEPTORS, useClass: HttperrorInterceptor, multi: true}
];
